import {Component, OnInit} from '@angular/core';
import {Project} from '../model/project';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {delay} from 'rxjs/operators';
import {of} from 'rxjs';
@Component(
    {
        selector:'notificationSlider',
        template:`
            <div>
                    <div [className]="toggleAnimation()">
                        <div class="closeX" (click)="toggleNotif()"><span><i style="color:white" class="fas fa-times"></i></span></div>

                        <div class="notifContent">
                            <div class="childDiv"><img alt="infoIcon" class="infoIcon" src="../../assets/images/informtion.png"></div>
                            <div class="childDiv alertDiv"><p class="alertMsg">{{alertMsg}}</p></div>
                        </div>
                    </div>
            </div>
        `,
        styles:[`
            .notif {
                width: 270px;
                height: 120px;
                background: #FFFFE1;
                border: 1px solid black;
                float: right;
                margin-top:170px;
                border-radius: 4px;
            }
            .notifAnimate{
                -webkit-animation: anim 1.5s;
                animation: anim 1.5s;
            }

            .notifWithdraw{
                -webkit-animation: anim-withdraw 1.5s;
                animation: anim-withdraw 1.5s 1 normal forwards;
            }

            .closeX {
                width: 22px;
                height: 22px;
                text-align: center;
                color: dimgray;
                font-weight: bold;
                float: right;
                margin-top: 3px;
                margin-right: 3px;
                background-color: #9A0000;
                border-radius: 3px;
            }

            .closeX:hover {background-color: red;}
            .infoIcon{width:22px;margin-left: 5px;}

            .alertMsg{font-weight: 900;font-size:smaller;color: black;}
            .childDiv,.alertMsg{float: left;}
            .alertDiv{width:89%;}
            .notifContent{
                text-align: center;
                margin-top:15%;
            }

            @-webkit-keyframes anim {
                from {left: 100%;}
                to {left: 30%;}
                /*0% {
                    transform: translateX(1550px);
                }
                14.28% {
                    transform: translateX(0);
                }
                85.71% {
                    transform: translateX(0);
                }
                100% {
                    transform: translateX(1550px);
                }*/
            }

            @keyframes anim {
                0% {
                    transform: translateX(200%);
                }
                100% {
                    transform: translateX(0%);
                }
            }

            @keyframes anim-withdraw {
                0% {
                    transform: translateX(0%);
                }
                100% {
                    transform: translateX(200%);
                }
            }
        `]
    })
export class NotificationComponent implements OnInit {
    constructor() {

    }

    private hide= true;
    private alertMsg='';
    private projectsToAlert:Project[];
    private maxProjToAlert;
    private currentIdx = 0;
    private animateWithdraw = false;

    static async waitAsync() {
        // return new Promise<boolean>((resolve, reject)=> {delay(1500); resolve(true);});
        return of({}).pipe(delay(1500)).toPromise();

    }

    ngOnInit(): void {
        this.projectsToAlert =  Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(JSON.parse(localStorage.getItem('projectsToNotif')),Project);

        this.maxProjToAlert = this.projectsToAlert.length;

        this.checkForNextAlert();
    }

    setAlertMsg(val:string) {
        this.alertMsg = 'A New project was added. ' + val+ '\n Check it out!';
        this.hide = false;
    }
/*
    setProjectsToAlert(value:Project[]) {
        this.projectsToAlert = value;
        this.maxProjToAlert = value.length;
    }*/

    async toggleNotif() {
        this.hide = true;
        this.animateWithdraw = true;
        this.toggleAnimation();
        this.currentIdx++;
        this.checkForNextAlert();

    }

    checkForNextAlert() {
        if (this.currentIdx < this.maxProjToAlert) {

            console.log(this.projectsToAlert[this.currentIdx].name);
            this.setAlertMsg(this.projectsToAlert[this.currentIdx].name);

            (async()=> {
                const val = await NotificationComponent.waitAsync();
                this.animateWithdraw = false;
                this.toggleAnimation();
            })();


            // tslint:disable-next-line:no-console
            // this.animateWithdraw = await NotificationComponent.waitFunction();
            // tslint:disable-next-line:no-console

        }
    }

    toggleAnimation():string {
        if(!this.animateWithdraw) {
           return 'notif notifAnimate';
        }
        return 'notif notifWithdraw';
    }
}
